/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getChatLabelStyles } from './styles/get-chat-label-styles';

export function ChatLabel(props) {
  const {
    onStartChat,
    i18n,
  } = props;

  const classes = useDefaultStyles(getChatLabelStyles);
  const [isChatButtonVisible, setIsChatButtonVisible] = useState(true);

  const onClickArrowButton = useCallback(() => {
    setIsChatButtonVisible(!isChatButtonVisible);
  }, [isChatButtonVisible]);

  return (
    <div className={classNames(classes.container, 'chat-label-container')}>
      <a
        className={classNames(
          classes.arrowButton,
          isChatButtonVisible ? classes.toHideArrowButton : classes.toShowArrowButton,
          'chat-label-arrow-button'
        )}
        onClick={onClickArrowButton}
      />
      {
        isChatButtonVisible &&
        <a
          className={classNames(classes.chatButton, 'chat-label-chat-button')}
          onClick={onStartChat}
        >
          {i18n.getString(_TL_('Question? Talk to an expert.'))}
        </a>
      }
    </div>
  );
}

ChatLabel.propTypes = {
  onStartChat: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
